import React from 'react';
import PropTypes from "prop-types";
import AdminOrderRow from "./adminOrderRow.js";

const AdminOrdersTable = ({orderBatches, setSortMethod, getOrderBatches}) => {
  return (
    <table className="table table-striped admin__table">
      <thead>
      <tr>
        <th onClick={() => setSortMethod('id')} className="sortable" scope="col">Id</th>
        <th onClick={() => setSortMethod('userId')} className="sortable" scope="col">User</th>
        <th onClick={() => setSortMethod('totalSum')} className="sortable" scope="col">Final sum</th>
        <th scope="col">Payment status</th>
        <th scope="col">Coupon</th>
        <th scope="col">Platform</th>
        <th onClick={() => setSortMethod('dateCreated')} className="sortable" scope="col">Date created</th>
        <th scope="col">Actions</th>
      </tr>
      </thead>
      <tbody>

      {
        orderBatches.map((orderBatch, index) => (
          <AdminOrderRow orderBatch={orderBatch} getOrderBatches={getOrderBatches} key={index}/>
        ))
      }

      </tbody>
    </table>
  );
};

AdminOrdersTable.propTypes = {
  orderBatches: PropTypes.array.isRequired,
  setSortMethod: PropTypes.func.isRequired,
  getOrderBatches: PropTypes.func.isRequired,
};

AdminOrdersTable.defaultProps = {};

export default AdminOrdersTable;
